import { Logger } from './class/Logger';

/*
 * Allow setting a logger on the global object because in Next.js creates separeate bundles for
 * instrumentation.ts and the app router server bundle which means they will each get their own logger.
 * By setting the logger on the global object they can be shared between bundles.
 */
declare global {
    var _nextLogger: Logger;
}

const logger = globalThis._nextLogger || new Logger('nēxt');

globalThis._nextLogger = logger;

export { logger };

export enum LoggerType {
    DISASSOCIATE_USER = 'DISASSOCIATE_USER',
    DELETE_USER = 'DELETE_USER',
}
